// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as ActivateUTSLogo } from "../../../assets/images/activate-uts-logo.svg";

import { type LinkType } from "../../types";

import Icon from "../atoms/Icon";
import LinkHandler from "../atoms/LinkHandler";
import FooterLinkList from "../molecules/FooterLinkList";

const SocialLink = (props: { list: {}, name: string }): React.Node => {
    if (props.list && props.list[props.name]) {
        return (
            <li className={`primary-footer__social-link ${props.name}`}>
                <LinkHandler
                    to={props.list[props.name].url}
                    target={props.list[props.name].target}
                >
                    <span
                        className={`primary-footer__social-link__icon primary-footer__social-link__icon--${props.name}`}
                    >
                        <Icon name={props.name} />
                    </span>
                    <span className="text">{props.list[props.name].title}</span>
                </LinkHandler>
            </li>
        );
    } else {
        return null;
    }
};

const PrimaryFooter = (): React.Node => {
    const firstNationAcknowledgment = useSelector((state: any): any => {
        return state.options.first_nations_acknowledgment;
    });
    const footerLinks: [{ link_list: [{ link: LinkType }] }] = useSelector(
        (state: any): any => {
            return state.options.footer_menu;
        }
    );
    const socialMediaLinks = useSelector((state: any): any => {
        return state.options.social_media_links;
    });
    const legalLinks: [{ link: LinkType }] = useSelector((state: any): any => {
        return state.options.legal_links;
    });

    const orderedSocialLinks = [
        "instagram",
        "facebook",
        "youtube",
        "linkedin",
        "tiktok",
    ];

    const handleBackToTopClick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };

    return (
        <div className="primary-footer">
            <div className="primary-footer__graphic"></div>
            <div className="container-fluid">
                <div className="primary-footer__inner">
                    <button
                        onClick={handleBackToTopClick}
                        type="button"
                        className="primary-footer__back-top-btn"
                    >
                        <Icon name="arrow-up" />
                    </button>

                    <div className="row">
                        <div className="col-xs-12 col-md-3">
                            <ActivateUTSLogo
                                className="primary-footer__logo"
                                alt="Activate UTS Logo"
                            />

                            <p className="primary-footer__acknowledgment">
                                {firstNationAcknowledgment}
                            </p>
                        </div>
                        <div className="col-xs-12 col-md-1" />
                        {footerLinks
                            ? footerLinks.map(
                                  ({ link_list }, index): React.Node => {
                                      return (
                                          <div
                                              key={index}
                                              className="col-xs-6 col-md-2"
                                          >
                                              <FooterLinkList
                                                  className="primary-footer__link-list"
                                                  list={link_list}
                                              />
                                          </div>
                                      );
                                  }
                              )
                            : null}
                        <div className="col-xs-6 col-md-2">
                            <h4 className="primary-footer__link-header">
                                Connect with us
                            </h4>
                            <ul>
                                {orderedSocialLinks.map(
                                    (name: string): React.Node => (
                                        <SocialLink
                                            key={name}
                                            name={name}
                                            list={socialMediaLinks}
                                        />
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="col-xs-6 col-md-2">
                            <p className="primary-footer__copyright">
                                &copy; ActivateUTS {new Date().getFullYear()}
                            </p>
                            <FooterLinkList list={legalLinks} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrimaryFooter;
